import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * Internal dependencies
 */
import PanelColorGradientSettings from '../colors-gradients/panel-color-gradient-settings';

const PanelColorSettings = _ref => {
  let {
    colorSettings,
    ...props
  } = _ref;
  const settings = colorSettings.map(setting => {
    if (!setting) {
      return setting;
    }

    const {
      value,
      onChange,
      ...otherSettings
    } = setting;
    return { ...otherSettings,
      colorValue: value,
      onColorChange: onChange
    };
  });
  return createElement(PanelColorGradientSettings, _extends({
    settings: settings,
    gradients: [],
    disableCustomGradients: true
  }, props));
};

export default PanelColorSettings;
//# sourceMappingURL=index.js.map